import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

const config = (user, params = {}) => ({
  headers: { Authorization: `Bearer ${user.token}` },
  params: { ...params, cache_bust: new Date().getTime() },
});

// Directores (de grupos sin fecha) y evaluadores del cuatrimestre, y si
// cargaron su disponibilidad. Solo admin.
export const getAvailabilityStatus = async (user, periodId) => {
  const response = await axios.get(`${BASE_URL}/availability/`, config(user, { period: periodId }));
  return response.data;
};

// Si el usuario logueado tiene que cargar disponibilidad y si ya lo hizo.
export const getMyAvailability = async (user, periodId) => {
  const response = await axios.get(`${BASE_URL}/availability/me`, config(user, { period: periodId }));
  return response.data;
};

// Deja pasar el error de axios: un 409 trae en `detail` por qué no se puede
// pedir (carga cerrada, no falta nadie) y la pantalla lo muestra.
export const previewAvailabilityRequest = async (user, periodId, deadline) => {
  const params = { period: periodId };
  if (deadline) params.deadline = deadline;
  const response = await axios.get(`${BASE_URL}/availability/request`, config(user, params));
  return response.data;
};

export const sendAvailabilityRequest = async (user, periodId, { deadline, replyTo, userIds }) => {
  const body = { deadline: deadline || null, reply_to: replyTo || null };
  if (userIds) body.user_ids = userIds;
  const response = await axios.post(
    `${BASE_URL}/availability/request`,
    body,
    config(user, { period: periodId })
  );
  return response.data;
};
